
// Layout.jsx
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navber";

export default function Layout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  // Load dark mode preference from localStorage on component mount
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedDarkMode);
  }, []);

  // Save dark mode preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('darkMode', darkMode.toString());
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const sidebarWidth = isCollapsed ? 80 : 320;

  return (
    <div className={`h-screen w-screen overflow-hidden flex transition-colors duration-300 ${
      darkMode ? 'dark bg-gray-900' : 'bg-gray-50'
    }`}>

      {/* Sidebar */}
      <div
        className="h-full transition-all duration-300 shadow-xl fixed z-50"
        style={{ width: `${sidebarWidth}px` }}
      >
        <Sidebar 
          isCollapsed={isCollapsed} 
          setIsCollapsed={setIsCollapsed}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
        />
      </div>

      {/* Main Content */}
      <div
        className="flex flex-col h-full transition-all duration-300 flex-1"
        style={{
          marginLeft: `${sidebarWidth}px`,
          width: `calc(100% - ${sidebarWidth}px)`,
          minWidth: 0, // Prevents overflow issues
        }}
      >
        <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
        <div className="flex-1 p-6 min-h-0 overflow-auto bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
          <div className="max-w-full"> {/* Changed from max-w-7xl to max-w-full */}
            <Outlet />
          </div>
        </div>
      </div>

    </div>
  );
}